export default {
	state: {
		loading: false,
		blackScreen: false
	},

	mutations: {
		setBlackScreenOnState(state, blackScreen) {
			state.blackScreen = blackScreen;
		}
	},

	actions: {},

	getters: {
		loading(state) {
			return state.loading;
		},
		blackScreen({ blackScreen }) {
			return blackScreen;
		}
	}
};
